import { useEffect } from "react"
import ReactDOM from "react-dom"
import { CloseIcon } from "./SvgIcons"
import Button from "../Primitive/Button"
import { setModalOpenFalse, setModalOpenTrue } from "./Modal"

type UnsavedChangesModalProps = {
    isOpen: boolean
    title: string
    message: string
    cancelLabel: string
    confirmLabel: string
    onCancel: () => void
    onConfirm: () => void
}

function UnsavedChangesModal({
    isOpen,
    title,
    message,
    cancelLabel,
    confirmLabel,
    onCancel,
    onConfirm,
}: UnsavedChangesModalProps) {
    useEffect(() => {
        if (!isOpen) {
            return
        }

        setModalOpenTrue()

        return () => {
            setModalOpenFalse()
        }
    }, [isOpen])

    if (!isOpen) {
        return null
    }

    return ReactDOM.createPortal(
        <>
            <div className="modal__overlay" onClick={onCancel}></div>

            <div className="modal__card">
                <div className="delete-room-modal">
                    <div className="delete-room-modal__content">
                        <div className="delete-room-modal__upper-panel">
                            <div className="delete-room-modal__title">{title}</div>
                            <div onClick={onCancel} className="delete-room-modal__close-icon">
                                <CloseIcon />
                            </div>
                        </div>
                        <div className="delete-room-modal__divider"></div>
                        <div className="delete-room-modal__middle-panel">
                            <div className="delete-room-modal__text">{message}</div>
                        </div>
                        <div className="delete-room-modal__button-container" style={{ display: "flex", gap: "0.5rem" }}>
                            <div className="delete-room-modal__button">
                                <Button
                                    onClick={onCancel}
                                    className="button button--font-size-small button--font-weight-400 button--text-color-white button--color-grey-c4 button--hover-brighter button--cursor-pointer button--border-radius-05"
                                >
                                    {cancelLabel}
                                </Button>
                            </div>
                            <div className="delete-room-modal__button">
                                <Button
                                    onClick={onConfirm}
                                    className="button button--font-size-small button--font-weight-400 button--text-color-white button--color-red button--hover-brighter button--cursor-pointer button--border-radius-05"
                                >
                                    {confirmLabel}
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>,
        document.getElementById("portal")!
    )
}

export default UnsavedChangesModal